// Module
var code = "<md-switch ng-model=\"$ctrl.licences\" aria-label=\"$ctrl.label\" ng-change=\"$ctrl.switchData()\">{{$ctrl.label}}</md-switch>\n";
// Exports
module.exports = code;